<template>
  <BTableCommonFormdata
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    :full-width-actions="false"
    dense
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.username="{ header, data, value: v }">
      <router-link
        v-if="!!header.getRoute"
        class="BTablePublicationFormdata__link"
        :to="header.getRoute(data)"
        v-text="v"
      />
      <span v-else v-text="v" />
    </template>

    <template #item.status="{ data }">
      <v-tooltip
        v-if="(!formdataDisabled && !['overdue', 'close'].includes(data.status)) ||
          (formdataDisabled && data.status === 'again_opened')
        "
        top
      >
        <template #activator="{ on }">
          <v-icon
            color="success"
            size="16px"
            class="mr-2"
            v-on="on"
            v-text="'mdi-checkbox-marked-outline'"
          />
        </template>
        <slot>
          <span>Отчет доступен для заполнения</span>
        </slot>
      </v-tooltip>

      <v-tooltip v-else top>
        <template #activator="{ on }">
          <v-icon
            color="error"
            size="16px"
            class="mr-2"
            v-on="on"
            v-text="'mdi-close-circle-outline'"
          />
        </template>
        <slot>
          <span>Отчет недоступен для заполнения</span>
        </slot>
      </v-tooltip>
    </template>

    <template #item.is_submitted="{ header, data }">
      <span>{{ header.field(data.status, data.is_submitted) }}</span>
    </template>
    <template #item.created_at="{ header, data }">
      <span v-if="!['open', 'prefilled'].includes(data.status)">{{ header.field(data.created_at, data.created_at) }}
      </span>
    </template>

    <!--  -->
  </BTableCommonFormdata>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/LKPublications/formdata/table-headers'
import BTableSimple from './BTableSimple.vue'
import BTableCommonFormdata from './BTableCommonFormdata.vue'


export default {
  name: 'BTablePublicationFormdata',
  components: {
    BTableCommonFormdata,
  },
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
    formdataDisabled: Boolean,
  },
}
</script>

<style>
.BTablePublicationFormdata__link {
  white-space: nowrap;
}

.BTablePublicationFormdata__user {
  max-width: 200px;
  overflow: hidden;
  text-overflow: unset;
  white-space: break-spaces;
}
</style>
